import PatientCreationPage from '@/pages/PatientCreationPage/PatientCreationPage.vue'

export default PatientCreationPage
